import { Controller } from "@hotwired/stimulus"

// Hides the whole element when the image inside it fails to load, e.g. an
// attendee photo whose CDN link has expired. Mount on the wrapper, mark the
// <img> as the target and give it data-action="error->hide-on-error#hide"
// (an image's error event doesn't bubble, so the action lives on the img).
// Replaces an inline onerror that the enforcing CSP blocks.
export default class extends Controller {
    static targets = ["img"]

    connect() {
        // A cached failure can fire before Stimulus connects.
        if (this.hasImgTarget && this.imgTarget.complete && this.imgTarget.naturalWidth === 0) this.hide()
    }

    hide() {
        this.element.style.display = "none"
    }
}
